import type { Product, Variant } from '@scayle/storefront-nuxt'
import { computed } from 'vue'
import { useState } from '#app/composables/state'
import { useSlideIn } from '#storefront-ui'
import { SIZE_BACK_IN_STOCK_SLIDEIN } from '~/constants'

interface BackInStockState {
  product: Product
  variant: Variant
  tab: string
}

export default function useBackInStockModal() {
  const state = useState<BackInStockState>(
    'backInStockModal',
    () => ({}) as BackInStockState,
  )

  const { toggle: toggleBackInStockSidebar } = useSlideIn(
    SIZE_BACK_IN_STOCK_SLIDEIN,
  )

  const setActiveItem = (
    activeVariant: Variant,
    tab: string,
    product?: Product,
  ) => {
    state.value = {
      variant: activeVariant,
      product: product as Product,
      tab,
    }
  }

  return {
    product: computed(() => state.value.product),
    variant: computed(() => state.value.variant),
    setActiveItem,
    toggleBackInStockSidebar,
    tab: computed(() => state.value.tab),
  }
}
